<div id="live-map-tracker">
    <a routerLink="/" class="link-btn">Back to Home</a>
    <iframe src="https://www.bing.com/covid"></iframe>
</div>